import * as React from "react";
import styled from "styled-components";
import { z } from "zod";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
export const BladeContentSchema = z.object({
    width: z.enum(["small", "medium", "large", "xlarge"]),
});
const _BladeContent = ({ children, width, className, ...props }) => {
    return (React.createElement("div", { className: [className, `width-${width}`].join(" "), ...props }, children));
};
_BladeContent.defaultProps = {
    "data-testid": "blade-content",
};
export const BladeContent = styled(_BladeContent) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BladeContent.js.map